import request from '../utils/request'

export function getNoticeTargets(params) {
  return request({
    url: '/api/admin/ops/resource-targets/notices',
    method: 'get',
    params
  })
}

export function getMerchantTargets(params) {
  return request({
    url: '/api/admin/ops/resource-targets/merchants',
    method: 'get',
    params
  })
}

export function getArtistTargets(params) {
  return request({
    url: '/api/admin/ops/resource-targets/artists',
    method: 'get',
    params
  })
}

export function getTopicTargets(params) {
  return request({
    url: '/api/admin/ops/resource-targets/topics',
    method: 'get',
    params
  })
}

export function getTaxonomyTargets(params) {
  return request({
    url: '/api/admin/ops/resource-targets/taxonomies',
    method: 'get',
    params
  })
}
